import {createTheme} from "@mui/material";

export const DefaultTheme = createTheme({

    palette: {
        mode: "light",
        primary: {
            main: '#0081C8',
            light: '#1B97E5', // 10% lighten
            dark: '#126497', // 10% darken
            contrastText: '#fff'
        },
        secondary: {
            main: '#4FB04D',
            light: '#71c070', // 10% lighten
            dark: '#3f8d3d', // 10% darken
            contrastText: '#fff',
        },
        background: {
            default: "#fff",
        },
        grey: {
            500: "#717c8e",
            800: "#242424"
        }
    },

});